export default Object.freeze([
  'Charlie',
  'Oscar',
  'Mike',
  'Victor',
  'Romeo'
]);



/** WEBPACK FOOTER **
 ** ./src/constants/names.js
 **/